/**
 * Hybrid Avatar Component
 * Automatically chooses between Tailwind and styled-components based on props.
 *
 * Routes to the styled-components path when a styled-system prop is present
 * (hasStyledProps), a BORDER-mixin prop is present (hasBorderProps — Avatar's
 * container uniquely applies the BORDER mixin), or the component was extended
 * with styled() (isStyledExtension). Otherwise renders the Tailwind path.
 */

import React from "react";
import {
  hasStyledProps,
  hasBorderProps,
  isStyledExtension,
} from "@sproutsocial/seeds-react-system-props";

import type { TypeAvatarProps } from "./AvatarTypes";
import AvatarStyled from "./AvatarStyled"; // Styled-components version
import { AvatarTailwind } from "./AvatarTailwind"; // Tailwind version

const AvatarHybrid = React.forwardRef<HTMLDivElement, TypeAvatarProps>(
  (props, ref) => {
    if (
      hasStyledProps(props) ||
      hasBorderProps(props) ||
      isStyledExtension(props)
    ) {
      return <AvatarStyled {...props} ref={ref} />;
    }

    // Use Tailwind version (preferred - better performance)
    return <AvatarTailwind {...props} ref={ref} />;
  }
);

AvatarHybrid.displayName = "Avatar";
export default AvatarHybrid;
